import { Form, Formik, Field } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormFooter from "../../../components/form-footer";
import IntakeWitnessDefendantStatementFocusQuestionsFields from '../../../components/intake/witness-defendant-statement/focus-questions-fields';
import { selectActiveFormWitnessDefendantStatementDetails, selectActiveFormWitnessDefendantStatementFocusQuestions, updateWitnessDefendantStatementFocusQuestions } from "../../../reducers/active-form-slice";
import FormHeaderButtons from '../form-header-buttons';


const IntakeWitnessDefendantStatementInfo = ({ nested }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    /**
     * get current form values
     */
    const witnessDefendantStatementDetails = useSelector(selectActiveFormWitnessDefendantStatementDetails);
    const witnessDefendantStatementFocusQuestions = useSelector(selectActiveFormWitnessDefendantStatementFocusQuestions);
    const hasValues =  witnessDefendantStatementFocusQuestions != null && Object.keys(witnessDefendantStatementFocusQuestions).length > 0 ? true : false;


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        if(witnessDefendantStatementDetails.statementType == "Witness") {
            navigate("/intake/witness-defendant-statement/witness-info");
        } else {
            navigate("/intake/witness-defendant-statement/defendant-info");
        }
    };

     /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateWitnessDefendantStatementFocusQuestions(values));
    };


    /**
     * update active form & continue
    */
    const handleSubmit = (values) => {
        dispatch(updateWitnessDefendantStatementFocusQuestions(values));
        navigate("/intake/additional-information");
    };

    /**
     * setup the initial values
     */
    const initialValues = {
        statementFocusQuestions: ''
    };


    return (
        <div className="page intake">
            <Formik
                onSubmit={handleSubmit}
                initialValues={hasValues ? witnessDefendantStatementFocusQuestions : initialValues}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Witness OR Defendant Statement Details</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>

                        <IntakeWitnessDefendantStatementFocusQuestionsFields
                            errors={errors}
                            touched={touched}
                            values={values}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={false}
                            showNext={true}
                            progress={`40`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeWitnessDefendantStatementInfo;